import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AdminAction } from 'src/app/models/adminaction.model';
import { SchoolModuleBatch } from 'src/app/models/module/moduledetails';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
import { SchoolmanagementService } from 'src/app/services/schoolmanagement.service';
import { UseraccessserviceService } from 'src/app/services/useraccessservice.service';
import { UtilService } from 'src/app/services/util.service';
declare const $: any;

@Component({
  selector: 'app-module-batches',
  templateUrl: './module-batches.component.html',
  styleUrls: ['./module-batches.component.css'],
})
export class ModuleBatchesComponent implements OnInit {
  moduleId: any;
  moduleInfo: any = {};
  adminActions: AdminAction[] = [];
  moduleBatches: SchoolModuleBatch[] = [];
  newModuleBatch: SchoolModuleBatch = {
    id: 0,
    name: '',
    startDate: undefined,
    endDate: undefined,
    moduleID: 0,
    meetingID: ''
  };
  minDate: any;
  constructor(
    public headerinfo: ComponentheaderService,
    private activatedroute: ActivatedRoute,
    public modulemanager: ModulemanagementService,
    private toastr: ToastrService,
    private router: Router,
    public util: UtilService
  ) {
    headerinfo.setHeaderDisplay('Loading Batches...', [], []);
  }
  async ngOnInit() {
    try {
      this.headerinfo.pageLoadingStarted(this);

      this.moduleId = this.activatedroute.snapshot.queryParams.moduleID;
      this.adminActions = [
        {
          displaytext: 'Create New Batch',
          route: '/user/viewmodulebatch',
          params: { moduleId: this.moduleId, batchID: 0 },
          classes: ['fas', 'fas fa-edit'],
        },
      ];
      this.headerinfo.setHeaderDisplay(
        'Batches',
        [
          { displaytext: 'School', route: `/user/schoolhome` },
          {
            displaytext: 'Course',
            route: `/user/moduledetails`,
            params: { moduleID: this.moduleId },
          },
          {
            displaytext: 'Batches',
            route: '/user/modulebatches',
            params: { moduleID: this.moduleId },
          },
        ],
        this.adminActions
      );

      this.moduleInfo = await this.modulemanager
        .getModuleInfo(this.moduleId)
        .toPromise();
      this.newModuleBatch.moduleID = this.moduleId;
      this.moduleBatches = await this.modulemanager
        .getModuleBatches(this.moduleId)
        .toPromise();
    } catch (error) {
      console.log(error);
    } finally {
      this.headerinfo.pageLoadingDone(this);
    }
  }


  async popNewBatch() {
    $('#newModuleBatch').modal('show');
  }

  async addNewBatch() {
    try {
      if (this.newModuleBatch.name == '') {
        this.toastr.error('Batch Name is required');
        return;
      }
      if (this.newModuleBatch.startDate == undefined) {
        this.toastr.error('Invalid Start Date');
        return;
      }
      if (
        this.newModuleBatch.endDate < this.newModuleBatch.startDate ||
        this.newModuleBatch.endDate == undefined
      ) {
        this.toastr.error('Invalid End Date');
        return;
      }

      await this.modulemanager
        .saveModuleBatch(this.newModuleBatch)
        .toPromise()
        .then(() => {
          this.toastr.success('Batch Saved.');
          window.location.reload();
        });
    } catch (error) {
      console.log(error);
    } finally {
      this.headerinfo.pageLoadingDone(this);
    }
  }

  navigateToDetails(id) {
    const queryParams = { batchID: id, moduleId: this.moduleId };
    this.router.navigate(['/user/viewmodulebatch'], {
      queryParams: queryParams,
    });
  }
}
